import { all, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import log from 'loglevel'

import { SOCKET_ACTION_TYPE } from '../../../../services/socket/constants'
import { sendMessage } from '../../../../services/socket/helpers'

import config from '../../../../config'

import { OPEN_LINKAGES_BY_ID } from './constants'

const MODULE_KEY = config.modules.linkages.key

function* onOpenLinkagesById(_action) {
    const linkagesId = _.get(_action, 'data.id', null)
    if (!linkagesId) return null

    if (config.iframeSolution) {
        // send message over websocket to old stack
        yield sendMessage(SOCKET_ACTION_TYPE.SHOW_MODULE_OUTPUT, { module: MODULE_KEY, entityId: linkagesId })
    } else {
        // open linkages in new stack
        log.info(`Open linkages for id ${linkagesId} in new stack`)
    }

    return null
}

export default function* linkagesSaga() {
    yield all([takeEvery(OPEN_LINKAGES_BY_ID, onOpenLinkagesById)])
}
